<template>
  <EntityList
    :config="config"
    :columns="columns"
    :form-fields="formFields"
    :allow-duplicate="false"
    authority="General_Post_Category"
  />
</template>

<script>
import EntityList from '@/layouts/entity/EntityList.vue'

import storeModule from '../productTagsStoreModule'

export default {
  components: {
    EntityList,
  },
  data() {
    return {
      tagsOptions: [],
    }
  },
  computed: {
    config() {
      return {
        store: storeModule,
        module: 'product-tags',
        endpoint: 'product-tags',
        route: 'product-tags',
        title: {
          single: this.$i18n.t('Product Tag'),
          plural: this.$i18n.t('Product Tags'),
        },
      }
    },

    columns() {
      return [
        { key: 'id', label: this.$t('id'), sortable: true },
        { key: 'title', label: this.$t('title'), sortable: true },
        { key: 'actions', label: this.$t('actions') },
      ]
    },
    formFields() {
      return [
        {
          id: 'title',
          type: 'text',
          label: this.$t('title'),
          options: this.tagsOptions,
          required: true,
        },
      ]
    },
  },
  mounted() {
    this.$store.dispatch('app-common/fetchTags').then(response => {
      this.tagsOptions = response.data
    })
  },
}
</script>
